export default __webpack_public_path__ + "static/media/garden.de71b433.png";